import { InspectionArea, InspectionItemNumberValues, InspectionItemType } from '@editor/interfaces/inspection'
import { InspectionGroup } from '@editor/interfaces/inspectionGroup'
import { ProjectSheetToleranceType } from '@editor/interfaces/project'
import { Shapes } from '@editor/interfaces/shape'
import { zeroPad } from '@editor/services/Util'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { InspectionItemLayer } from '../interfaces'
import MetricsGroup from './MetricsGroup'
import ModeledItem from './ModeledItem/ModeledItem'

interface LayerProps {
  inspectionArea: InspectionArea
  group?: InspectionGroup
  item: InspectionItemLayer
  items: InspectionItemLayer[]
  shapes: Shapes

  /**
   * All additional metrics' toggle state, including ones not belonging to this metric.
   */
  allAdditionalMetricsToggle?: boolean[]
}

const Layer = ({ inspectionArea, group, item, items, shapes, allAdditionalMetricsToggle }: LayerProps) => {
  // Store
  const settings = useSelector((state: RootState) => state.inspectionSheet.settings)

  return item.item_type === InspectionItemType.LengthWithDistanceTool ? (
    <MetricsGroup
      group={group}
      title="手動計測した距離"
      itemsDefaulTitle={(it, index) => `距離${zeroPad(index + 1, 3)}`}
      unit="mm"
      nameChangeable
      inspectionItems={items}
      inspectionItemValues={items.map((it) => it.length_with_distance_tool) as InspectionItemNumberValues[]}
      isMetricsHidden={false}
      allAdditionalMetricsToggle={allAdditionalMetricsToggle}
      toleranceType={
        settings.sheet_rows_tolerance_type?.length_with_distance_tool || ProjectSheetToleranceType.WithinTolerance
      }
    />
  ) : (
    <ModeledItem
      key={`modeled-item-${item.inspection_item_id}`}
      allAdditionalMetricsToggle={allAdditionalMetricsToggle}
      defaultTitle={item.default_part_name || ''}
      title={item.part_name}
      inspectionItems={items}
      inspectionArea={inspectionArea}
      shapes={shapes}
      group={group}
    />
  )
}

export default Layer
